import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import {useEffect} from "react";
import {
    getEstimateSectionList,
    uploadSectionPositionDown,
    uploadSectionPositionUp
} from "../../../api/admin/estimateReq";
import useData from "../../../hooks/useData";
import {Link} from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { sortSections } from "../../../helper/tools";

export default function ViewEstimateSectionOrder() {

    const source = "fa fa-table-list";
    const tabSource = "fa fa-bars";
    const { estimateSectionList, setEstimateSectionList } = useData();
    const { auth } = useAuth();
    const token = auth.token;

    const apiEstimateSectionList = async () => {
        const response = await getEstimateSectionList(token)
        setEstimateSectionList(response)
    }

    const handleSectionUp = async (id) => {
        await uploadSectionPositionUp(token, id)
        apiEstimateSectionList()
    }

    const handleSectionDown = async (id) => {
        await uploadSectionPositionDown(token, id)
        apiEstimateSectionList()
    }

    useEffect(() => {
        apiEstimateSectionList()
    }, []);

    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Devis"
            />
            <nav className="tabs-menu">
                <li><Link to="/admin/documents">Voir les documents</Link></li>
                <li className="active"><Link to="/admin/documents/devis/section/1/voir">Voir les devis type</Link></li>
                <li><Link to="/admin/documents/devis/categories">Gérer les catégories</Link></li>
            </nav>
            <div className="flex">
                <div className="content-container">
                    <div className="dashboard">
                        <Icon source={ source } color="blue" span="Ordre des sections de devis"/>
                        <table>
                            <thead>
                            <tr>
                                <th>Numéro de section</th>
                                <th>Description</th>
                                <th>Déplacement</th>
                            </tr>
                            </thead>
                            <tbody>
                            { sortSections(estimateSectionList)?.map(section => (
                                <tr key={section?.id}>
                                    <td>{section?.section}</td>
                                    <td>{section?.description}</td>
                                    <td className="up-down-section">
                                        <i className="fa fa-arrow-down" onClick={() => handleSectionUp(section?.id)}></i>
                                        <i className="fa fa-arrow-up" onClick={() => handleSectionDown(section?.id)}></i>
                                    </td>
                                </tr>
                            ))
                            }
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </main>
    )
}